import { Icon } from '../components/Icon';
import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { ABOUT, PARTNERS, TEAM, VALUES } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

export function AboutPage() {
  useDocumentMeta({
    title: 'Sobre Nosotros | Corporación Indemniza',
    description: 'Conoce la historia, misión, visión, valores y equipo de Corporación Indemniza.',
    canonicalPath: '/sobre-nosotros',
  });


  return (
    <div className="about-page">
      <PageHero
        image={ABOUT.heroImage}
        position={ABOUT.heroPosition}
        mobilePosition={ABOUT.heroMobilePosition}
        eyebrow="Sobre nosotros"
        title="Somos Corporación Indemniza"
        subtitle="Especialistas exclusivos en reparación y compensación legal de daños."
      />

      <section className="about-story" aria-labelledby="about-story-title">
        <div className="site-container about-story__grid">
          <Reveal as="figure" className="about-story__image" direction="left">
            <img src={ABOUT.building} alt="Edificio donde se encuentra Corporación Indemniza" loading="eager" />
          </Reveal>
          <Reveal className="about-story__copy" direction="right" delay={80}>
            <p className="eyebrow">{ABOUT.story.eyebrow}</p>
            <h2 id="about-story-title">{ABOUT.story.title}</h2>
            {ABOUT.story.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </Reveal>
        </div>
      </section>

      <section className="about-purpose" aria-label="Visión y misión">
        <div className="site-container about-purpose__grid">
          <Reveal as="article" className="purpose-card" direction="left">
            <span className="purpose-card__icon"><Icon name="eye" size={24} /></span>
            <h2>Visión</h2>
            <p>Brindar una representación legal experta, estratégica e implacable para buscar que cada cliente obtenga la reparación y compensación que correspondan por los daños sufridos, acompañándolo con total transparencia y ética profesional.</p>
          </Reveal>
          <Reveal as="article" className="purpose-card" direction="right" delay={80}>
            <span className="purpose-card__icon"><Icon name="shield" size={24} /></span>
            <h2>Misión</h2>
            <p>Consolidarnos como un estudio de abogados referente a nivel nacional en materia de indemnizaciones y reparación de daños, mediante especialización técnica, experiencia y compromiso con cada caso.</p>
          </Reveal>
        </div>
      </section>

      <section className="about-values" aria-labelledby="about-values-title">
        <div className="site-container">
          <Reveal as="header" className="section-intro section-intro--compact">
            <p className="eyebrow">Lo que nos define</p>
            <h2 id="about-values-title">Nuestros valores</h2>
          </Reveal>
          <div className="values-grid">
            {VALUES.map((value, index) => (
              <Reveal as="article" className="value-card" delay={index * 65} key={value.title}>
                <span><Icon name={value.icon} size={21} /></span>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="about-team" aria-labelledby="about-team-title">
        <div className="site-container">
          <Reveal as="header" className="section-intro section-intro--light section-intro--compact">
            <p className="eyebrow">Nuestro equipo</p>
            <h2 id="about-team-title">Quiénes te representan</h2>
            <p>Un equipo de especialistas comprometidos con la reparación de tus daños.</p>
          </Reveal>
          <div className="team-grid">
            {TEAM.map((member, index) => (
              <Reveal as="article" className="team-card" delay={index * 80} key={`${member.name}-${index}`}>
                <div className="team-card__photo"><img src={member.image} alt={member.name} loading="lazy" /></div>
                <h3>{member.name}</h3>
                <p className="team-card__role">{member.role}</p>
                <p>{member.area}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="about-partners" aria-labelledby="partners-title">
        <Reveal as="header" className="section-intro section-intro--compact">
          <p className="eyebrow">Confían en nosotros</p>
          <h2 id="partners-title">Aliado estratégico</h2>
        </Reveal>
        <div className="partners-marquee" aria-label="Aliado estratégico">
          <div className="partners-marquee__track">
            {PARTNERS.map((partner) => (
              <div
                className="partner-logo"
                key={partner.name}
              >
                <img
                  src={partner.image}
                  alt={partner.name}
                  loading="lazy"
                />

                <span>{partner.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
